<script>
  import { getContext } from 'svelte'
  import { formatThousands, formatDateLong } from './functions'
  import { onMount } from 'svelte'
  import Axis from './components/Axis.svelte'
  import { scaleLinear, scaleTime } from 'd3-scale'
  import { extent, max } from 'd3-array'
  import Bar from './components/Bar.svelte'
  import { colors } from './colors.js'
  import Line from './components/Line.svelte'
  import Grid from './components/Grid.svelte'
  let days = 30
  export let cumulativeData
  let padding = 5
  let width
  let height = 300
  let latestVaccCount
  let latestDate
  onMount(async () => {
    addLineChart()
  })

  let { margin, nData, cData } = getContext('chart')
  let originalCumulativeData = cData()
  cumulativeData = originalCumulativeData

  function addLineChart() {
    cumulativeData.forEach((d) => {
      d.cases_daily = +d.cases_daily
      d.vaccinated_daily = +d.vaccinated_daily
      d.vaccinationsSevenDays = +d.vaccinationsSevenDays
    })
    cumulativeData = cumulativeData.filter(
      (d, i) => i > cumulativeData.length - days
    )
    cumulativeData = cumulativeData.filter((d) => d.vaccinated_daily > 0)
  }
  function changeData(days) {
    cumulativeData = cumulativeData.filter(
      (d, i) => i > cumulativeData.length - days
    )
  }

  $: xScale = scaleTime()
    .range([margin.left, width - margin.right])
    .domain(extent(cumulativeData, (d) => d.date))

  $: yScale = scaleLinear()
    .range([height - margin.bottom, margin.top])
    .domain([0, max(originalCumulativeData, (d) => +d.vaccinated_daily)])

  $: xTicks = xScale.ticks(5)
  $: yTicks = yScale.ticks(5)

  onMount(() => {
    addLineChart()
  })

  $: if (days) {
    if (days === 30) padding = 5
    else if (days > 55) padding = 2

    cumulativeData = originalCumulativeData.filter(
      (d, i) => i > originalCumulativeData.length - days
    )
  }
</script>

<div class="chart-wrap">
  <div class="chart-title">Daily Vaccinations In SA</div>
  <div class="chart-description">
    <span style="color: {colors['blue700']};">Daily Vaccinations</span>
    <br />
    <span style="color: {colors['red700']};">7-Day Average Vaccinations</span
    ><br />
    <div class="top-spacer options">
      Last 30 Days
      <input
        type="radio"
        name="days"
        checked="checked"
        bind:group={days}
        value={30}
      />
      60 Days
      <input type="radio" name="days" bind:group={days} value={60} />

      90 Days
      <input type="radio" name="days" bind:group={days} value={90} />
    </div>
  </div>
  <div class="chart chart-daily chart-block" bind:clientWidth={width}>
    <div class="tooltip">Tooltip</div>
    <div class="latest-data">
      <div class="latest-number">{formatThousands(latestVaccCount)}</div>
      <div class="latest-date">{formatDateLong(latestDate)}</div>
    </div>
    <svg {height} {width}>
      <Grid
        type="y"
        ticks={{ x: xTicks, y: yTicks }}
        scale={{ x: xScale, y: yScale }}
        {height}
        {width}
      />
      <Axis
        type="x"
        ticks={{ x: xTicks, y: yTicks }}
        scale={{ x: xScale, y: yScale }}
        {height}
        {width}
      />
      <Axis
        type="y"
        ticks={{ x: xTicks, y: yTicks }}
        scale={{ x: xScale, y: yScale }}
        {height}
        {width}
      />

      <Bar
        {width}
        {height}
        ticks={{ x: xTicks, y: yTicks }}
        data={cumulativeData}
        scale={{ x: xScale, y: yScale }}
        {padding}
        values={{ x: 'date', y: 'vaccinated_daily' }}
        fill={colors['blue500']}
      />

      <Line
        {width}
        {height}
        scale={{ x: xScale, y: yScale }}
        values={{ x: 'date', y: 'vaccinations_7_day_average' }}
        data={cumulativeData}
        strokeWidth="3"
        stroke={colors['red700']}
      />
    </svg>
  </div>
</div>

<style>
  .chart {
    position: relative;
    font-family: 'Titillium Web', Arial, Helvetica, sans-serif;
    width: 100%;

    min-height: 250px;
    margin: 0 auto;
  }

  .latest-data {
    position: absolute;
    top: 20px;
    left: 20px;
    line-height: 100%;
    left: -10000px;
  }
  .latest-number {
    background: var(--darkgreen);
    color: #fff;
    padding: 4px 6px;
    font-size: 80%;
    border-radius: 5px;
  }
</style>
